<!--
 * @Author: mazhigang
 * @Date: 2023-07-03 17:43:22
 * @LastEditors: mazhigang
 * @LastEditTime: 2023-09-02 20:59:58
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>标签管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">标签列表</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="标签名称">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.name"
                    placeholder="请输入标签名称"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="状态">
                  <el-select
                    v-model="ruleForm.status"
                    placeholder="请选择状态"
                    style="margin-right: auto"
                  >
                    <el-option label="停用" value="0"></el-option>
                    <el-option label="启用" value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item>
                  <el-button type="primary" @click="getList()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <el-button
          type="primary"
          class="btn"
          style="margin-bottom: 16px"
          @click="add()"
          >添加</el-button
        >
        <el-table ref="scrollTable" :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="编号" align="center">
          </el-table-column>
          <el-table-column prop="name" label="标签名称" align="center">
          </el-table-column>
          <el-table-column label="分类名称" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.categoryName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="发布时间" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.gmtCreate }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <span class="redColor" v-if="scope.row.status == 0">停用</span>
              <span class="greenColor" v-if="scope.row.status == 1">启用</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <div class="disAround">
                <div
                  class="operateBtn greenColor1"
                  @click="stop(scope.row)"
                  v-if="scope.row.status == 0"
                >
                  启用
                </div>
                <div
                  class="operateBtn redColor1"
                  @click="stop(scope.row)"
                  v-if="scope.row.status == 1"
                >
                  停用
                </div>
                <div
                  class="operateBtn redColor1"
                  @click="deleteItem(scope.row)"
                  v-if="scope.row.status == 0"
                >
                  删除
                </div>
                <div
                  class="operateBtn"
                  @click="edit(scope.row)"
                  v-if="scope.row.status == 0"
                >
                  编辑
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="600px">
      <el-form
        label-position="right"
        :model="ruleForm1"
        :rules="rules"
        ref="ruleForm"
        style="margin: 0 auto"
      >
        <el-form-item label="分类" prop="type">
          <el-cascader
            v-model="ruleForm1.type"
            style="margin-right: auto"
            :props="cateProps"
            :show-all-levels="false"
            :options="list"
            @change="handleChange"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="标签名称" prop="name">
          <el-input
            v-model="ruleForm1.name"
            placeholder="请输入标签名称"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item
          label="发布状态"
          prop="status"
          style="display: flex;align-items: center;"
        >
          <el-radio-group v-model="ruleForm1.status">
            <el-radio label="1">启用</el-radio>
            <el-radio label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item>
          <el-button @click="resetForm1('ruleForm')">取消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.operateData(),
      ruleForm: {
        name: "",
        status: "",
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      dialogFormVisible: false,
      title: "新增标签",
      ruleForm1: {
        type: "",
        status: "1",
        name: "",
      },
      rules: {
        type: [{ required: true, message: "必选项", trigger: "change" }],
        name: [{ required: true, message: "必选项", trigger: "blur" }],
        status: [{ required: true, message: "必选项", trigger: "change" }],
      },
      editId: "",
      cateProps: {
        label: "name",
        value: "id",
        checkStrictly: true,
      },
      list: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getListClass() {
      let param = {
        page: 1,
        pageSize: 1000,
        queryParams: [
          {
            name: "page_module",
            type: "select",
            values: [
              {
                itemKey: 3,
              },
            ],
          },
        ],
      };
      this.$axios
        .post(`/admapi/categories/list`, param)
        .then(({ data }) => {
          this.list = data;
        })
        .catch()
        .finally();
    },
    handleChange(val) {
      this.ruleForm1.type = val[val.length - 1];
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {
            categoryId: this.ruleForm1.type,
            name: this.ruleForm1.name,
            state: this.ruleForm1.status,
          };
          if (this.editId == "") {
            this.$axios
              .post(`/admapi/tag/add`, param)
              .then(({ data }) => {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.getList();
              })
              .catch()
              .finally(() => {
                this.dialogFormVisible = false;
                this.ruleForm1.type = "";
                this.ruleForm1.name = "";
              });
          } else {
            param.id = this.editId;
            this.$axios
              .post(`/admapi/tag/update`, param)
              .then(({ data }) => {
                this.$message({
                  message: "编辑成功",
                  type: "success",
                });
                this.getList();
              })
              .catch()
              .finally(() => {
                this.dialogFormVisible = false;
                this.editId = "";
                this.ruleForm1.type = "";
                this.ruleForm1.name = "";
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm1(formName) {
      this.$refs[formName].resetFields();
      this.dialogFormVisible = false;
    },
    resetForm() {
      this.ruleForm.name = "";
      this.ruleForm.status = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        queryParams: [],
      };
      if (this.ruleForm.name != "") {
        param.queryParams.push({
          name: "name",
          type: "input",
          value: this.ruleForm.name,
        });
      } else if (this.ruleForm.status != "") {
        param.queryParams.push({
          name: "status",
          type: "select",
          values: [{ itemKey: this.ruleForm.status }],
        });
      }
      this.$axios
        .post(`/admapi/tag/list`, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
    add() {
      this.title = "新增标签";
      this.dialogFormVisible = true;
      this.editId = "";
      this.getListClass();
    },
    edit(val) {
      this.getListClass();
      this.editId = val.id;
      this.title = "编辑标签";
      this.ruleForm1.type = val.categoryId;
      this.ruleForm1.name = val.name;
      this.ruleForm1.status = val.status;
      this.dialogFormVisible = true;
    },
    stop(val) {
      this.$confirm(val.status == 0 ? "是否启用" : "是否禁用", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let param = {
            id: val.id,
            state: val.status == 0 ? 1 : 0,
          };
          this.$axios
            .post(`/admapi/tag/publish`, param)
            .then(({ data }) => {
              this.$message({
                message: val.status == 1 ? "禁用成功" : "启用成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
    deleteItem(val) {
      this.$confirm("是否删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(`/admapi/tag/delete/${val.id}`)
            .then(({ data }) => {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped></style>
